import { useMemo } from 'react'
import { useBrodMigdal } from '../../../../../generic/hooks/useBrodMigdal'

export interface IKnisaConfigItem {
  refValue: 'boolean' | 'number'
  code: string
  value: boolean | number
}
export const useKnisaConfig = () => {
  const { getBrodMigdal } = useBrodMigdal()

  const config = useMemo(() => {
    const defaultGrower = getBrodMigdal({ id: 4 }) as number
    const isReqiredCar = !!getBrodMigdal({ id: 618 })
    const defaultCar = getBrodMigdal({ id: 395 }) as number

    const isReqiredTranzit = !!getBrodMigdal({ id: 6 })
    const defaultTranzit = getBrodMigdal({ id: 5 }) as number

    const defaultPackage = getBrodMigdal({ id: 204 }) as number

    const isReqieredWeight = !!getBrodMigdal({ id: 556 })
    const isCopyLineWithWeight = !!getBrodMigdal({ id: 423 })
    const isReqiredRef = !!getBrodMigdal({ id: 220 })

    const defaultPallet = getBrodMigdal({ id: 354 }) as number
    const defaultSugTeuda = getBrodMigdal({ id: 179, subId: 'כניסה' }) as number

    const defaultProductID = getBrodMigdal({ id: 7 }) as number
    const defaultVarietyID = getBrodMigdal({ id: 8 }) as number
    const isAllowToChangeTranzit = !!getBrodMigdal({ id: 405 })
    const defaultToPalletValue = !!getBrodMigdal({ id: 658 })

    return {
      create: {
        title: {
          subTeuda: [
            {
              refValue: 'number',
              code: 'DF179',
              value: defaultSugTeuda
            }
          ],
          grower: [
            {
              refValue: 'number',
              code: 'DF4',
              value: defaultGrower
            },
          ],
          car: [
            {
              refValue: 'boolean',
              code: 'DF618',
              value: isReqiredCar
            },
            {
              refValue: 'number',
              code: 'DF395',
              value: defaultCar
            }
          ],
          tranzit: [
            {
              refValue: 'boolean',
              code: 'DF6',
              value: isReqiredTranzit
            },
            {
              refValue: 'number',
              code: 'DF5',
              value: defaultTranzit
            }
          ],
          ref: [
            {
              refValue: 'boolean',
              code: 'DF220',
              value: isReqiredRef
            }
          ]
        },
        details: {
          package: [
            {
              refValue: 'number',
              code: 'DF382',
              value: defaultPackage
            }
          ],
          weight: [
            {
              refValue: 'boolean',
              code: 'DF556',
              value: isReqieredWeight
            }
          ],
          multuplier: [
            {
              refValue: 'boolean',
              code: 'DF423',
              value: isCopyLineWithWeight
            }
          ],
          pallet: [
            {
              refValue: 'number',
              code: 'DF354',
              value: defaultPallet
            }
          ],
          productID: [
            {
              refValue: 'number',
              code: 'DF7',
              value: defaultProductID
            }
          ],
          varietyID: [
            {
              refValue: 'number',
              code: 'DF8',
              value: defaultVarietyID
            }
          ],
          tranzit: [
            {
              refValue: 'boolean',
              code: 'DF405',
              value: isAllowToChangeTranzit
            }
          ],
          toPallet: [
            {
              refValue: 'boolean',
              code: 'DF658',
              value: defaultToPalletValue
            }
          ]

        }
      }
    }
  }, [getBrodMigdal])

  return config
}
